import { trackCallClick } from "@/lib/analytics";

interface CallLinkProps {
  children: React.ReactNode;
  location: string;
  label?: string;
  className?: string;
  ariaLabel?: string;
}

export function CallLink({ children, location, label, className, ariaLabel }: CallLinkProps) {
  return (
    <a
      href="tel:+916364894003"
      aria-label={ariaLabel || `Call ${label || location}`}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        trackCallClick(location, label);
        // Small delay lets the dataLayer push reach GTM before the OS dialer opens.
        setTimeout(() => {
          window.location.href = "tel:+916364894003";
        }, 120);
      }}
    >
      {children}
    </a>
  );
}
